import React, { FC, useCallback, useContext, useState } from 'react';

import { IBigBannerSlide } from './_Slide/models';
import { BigBannerSlide } from './_Slide/BigBannerSlide';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { Box } from '@src/atoms/Box';
import { Skeleton } from '@src/atoms/Skeleton/Skeleton';
import { Unit } from '@src/core/Unit';
import { Slider } from '@src/atoms/Slider';
import { IClassNameProps, ILoadingProps, IStylesProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import { FeedbackForm } from '../FeedbackForm';
import { TFeedbackData } from './models';

import styled from './BigBanner.scss';

interface IProps extends IClassNameProps, IStylesProps, ILoadingProps {
  /** Список слайдов */
  slides: IBigBannerSlide[];
}

export const BigBanner: FC<IProps> = ({ slides, loading, className, style }) => {
  const { isMobile } = useContext(BreakpointsContext);
  const [feedbackData, setFeedbackFormData] = useState<TFeedbackData>({});

  const classes = classnames(className, styled.root, {
    [styled.loading]: loading,
  });

  const handleClose = useCallback(() => {
    setFeedbackFormData({
      data: undefined,
      formType: undefined,
    });
  }, []);

  if (loading) {
    return (
      <Box className={classes} column justifyContent="spaceBetween">
        <div className={styled.slide}>
          <div className={styled.skeleton}>
            <Skeleton />
          </div>
        </div>
      </Box>
    );
  }

  return (
    <Unit id={'BigBanner'}>
      <Box className={classes} style={style} column justifyContent="spaceBetween">
        <Slider autoplay arrows={!isMobile} fade infinite dots swipe>
          {slides?.map((slide: IBigBannerSlide) => (
            <BigBannerSlide key={slide.id} {...slide} changeFeedbackData={setFeedbackFormData} />
          ))}
        </Slider>
        <FeedbackForm onClose={handleClose} data={feedbackData.data} feedbackFormType={feedbackData.formType} />
      </Box>
    </Unit>
  );
};
